import { invisiblyApi } from '../api/invisibly-api';
import { RootState } from '../redux-store';
import { submitFeedbackRequest } from './feedback.api';
import { FeedbackRequest, FeedbackSubmissionError, FeedbackSuccessResponse } from './feedback.types';

const feedbackEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    submitFeedback: builder.mutation<FeedbackSuccessResponse, FeedbackRequest>({
      queryFn: async(request, { getState }) => {
        try {
          const { userState: { access } } = getState() as RootState;
          const data = await submitFeedbackRequest(request, access);
          return { data };
        } catch (error) {
          return {
            error: error as FeedbackSubmissionError,
          };
        }
      },
    }),
  }),
  overrideExisting: true,
});

export const { useSubmitFeedbackMutation } = feedbackEndpoints;
